// import HotelIcon from '../../stories/Icons/HotelIcon';
import {defaultTheme} from '@stencil/build-theme';
import React from 'react';
// import GoStaysIcon from '../../stories/Icons/GoStaysIcon';
import CoupleFriendlyIcon from '../../stories/Icons/CoupleFriendlyIcon';
import FlameIcon from '../../stories/Icons/FlameIcon';
import GiftTagIcon from '../../stories/Icons/GiftTagIcon';
import LocationIcon from '../../stories/Icons/LocationIcon';
// import OyoRoomsIcon from '../../stories/Icons/OyoRoomsIcon';
// import RoundedCheckbox from '../../stories/Icons/RoundedCheckbox';
import OfferIcon from '../../stories/Icons/OfferIcon';
import ShieldIcon from '../../stories/Icons/ShieldIcon';
import UgcPersuasionIcon from '../../stories/Icons/UgcPersuasionIcon';
// import HotelIcon from '../../stories/Icons/HotelIcon';
import SocialIcon from '../../stories/Icons/SocialIcon';
import FreeCancellationIcon from '../../stories/Icons/Amenities/FreeCancellationIcon';
import FreeBreakfast from '../../stories/Icons/Amenities/FreeBreakfast';
import SwimmingIcon from '../../stories/Icons/Amenities/SwimmingIcon';
import GocashOfferIcon from '../../stories/Icons/GocashIconOffer';
import GoSafeSheildLogo from '../../stories/Icons/goSafeSheildLogo';

const HermesIconSelector = ({name, styleProps}: {name: string; styleProps: object}) => {
  // if (!name)
  //   return (
  //     <HotelIcon
  //       fill={defaultTheme.colors.downriver.medium}
  //       height="1.5rem"
  //       width="1.5rem"
  //       {...styleProps}
  //     />
  //   );

  switch (name) {
    // case 'tGostay':
    //   return <GoStaysIcon {...styleProps} />;
    case 'tCoupleFriendly':
      return <CoupleFriendlyIcon {...styleProps} />;

    // case 'tOyo':
    //   return <OyoRoomsIcon {...styleProps} />;
    case 'tDiscount':
      return <OfferIcon {...styleProps} />;
    case 'tCoin':
      return <OfferIcon {...styleProps} />;
    case 'tStealDeal':
      return <OfferIcon {...styleProps} />;
    case 'tVoyagerPer':
      return <UgcPersuasionIcon {...styleProps} />;
    case 'tFreeCancel':
      return <ShieldIcon {...styleProps} />;
    case 'tShieldIcon':
      return <ShieldIcon {...styleProps} />;
    case 'tLocation':
      return <LocationIcon {...styleProps} />;
    case 'tFlame':
      return <FlameIcon {...styleProps} />;
    case 'tFreeCancel':
      return <FreeCancellationIcon {...styleProps} />;
    case 'tFreeBrkFast':
      return <FreeBreakfast {...styleProps} />;
    case 'tSocial':
      return <SocialIcon {...styleProps} />;
    case 'Swimming':
      return <SwimmingIcon {...styleProps} />;
    case 'tGosafe':
      return <GoSafeSheildLogo {...styleProps} />;
    // case 'taHotels':
    //   return (
    //     <HotelIcon
    //       fill={defaultTheme.colors.downriver.medium}
    //       height="1.5rem"
    //       width="1.5rem"
    //       {...styleProps}
    //     />
    //   );
    default:
      return (
        <GiftTagIcon
          fill={defaultTheme.colors.downriver.medium}
          height="1.5rem"
          width="1.5rem"
          {...styleProps}
        />
      );
  }
};

export default HermesIconSelector;
